var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"userName"},[_vm._v(_vm._s(this.username))])])
}
var staticRenderFns = []

export { render, staticRenderFns }